export type MenuItemType = {
    key: string;
    label: string;
    isTitle?: boolean;
    icon?: string;
    url?: string;
    badge?: {
        variant: string;
        text: string;
    };
    parentKey?: string;
    target?: string;
    hide?: boolean;
    urlsToReload?: (string|RegExp)[];
    children?: MenuItemType[];
};

const MENU_ITEMS: MenuItemType[] = [
    { key: 'navigation', label: 'Menu Principal', isTitle: true },
    // {
    //     key: 'dashboard',
    //     label: 'Dashboard',
    //     isTitle: false,
    //     icon: 'uil-home-alt',
    //     url: '/dashboard',
    // },
    {
        key: 'courses',
        label: 'Gestão de Cursos',
        isTitle: false,
        icon: 'uil-books',
        url: '/gestao/cursos',
    },
    {
        key: 'classes',
        label: 'Gestão de Turmas',
        isTitle: false,
        icon: 'uil-book-reader',
        url: '/gestao/turmas',
    },
    {
        key: 'modules',
        label: 'Gestão de Módulos',
        isTitle: false,
        icon: 'uil-notebooks',
        url: '/gestao/modulos',
        urlsToReload: [
            /\b(modulos\/[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89aAbB][a-f0-9]{3}-[a-f0-9]{12})\b/
        ]
    },
    {
        key: 'content',
        label: 'Gestão de Conteúdo',
        isTitle: false,
        icon: 'uil-apps',
        url: '/gestao-conteudo',
    },
    // {
    //     key: 'groups',
    //     label: 'Gestão de Grupos',
    //     isTitle: false,
    //     icon: 'uil-layer-group',
    //     url: '/gestao/grupos'
    // },
    {
        key: 'users',
        label: 'Gestão de Usuários',
        isTitle: false,
        icon: 'uil-users-alt',//uil-wrap-text
        url: '/gestao/usuarios'
    },
    {
        key: 'cancel-requests',
        label: 'Pedidos Cancelamento',
        isTitle: false,
        icon: 'uil-user-times',
        url: '/gestao/usuarios-cancelamentos'
    },
    {
        key: 'messages',
        label: 'Mensagens',
        isTitle: false,
        icon: 'uil-comment-alt-message',
        url: '/gestao/mensagens'
    },
    {
        key: 'orders',
        label: 'Gestão de Ordens',
        isTitle: false,
        icon: 'uil-wrap-text',
        children: [
            {
                key: 'orders-classes',
                label: 'Cursos',
                isTitle: false,
                parentKey: 'orders',
                url: '/gestao/ordens/cursos'
            },
            {
                key: 'orders-modules',
                label: 'Módulos',
                isTitle: false,
                parentKey: 'orders',
                url: '/gestao/ordens/modulos'
            },
            {
                key: 'orders-contents',
                label: 'Conteúdos',
                isTitle: false,
                parentKey: 'orders',
                url: '/gestao/ordens/conteudos'
            }
        ]
    },
    // {
    //     key: 'messages',
    //     label: 'Gestão de Mensagens',
    //     isTitle: false,
    //     icon: 'uil-comments',
    //     url: '/gestao/mensagens'
    // },
    // {
    //     key: 'comments',
    //     label: 'Gestão de Comentários',
    //     isTitle: false,
    //     icon: 'uil-comment-alt-message',
    //     url: '/gestao/comentarios'
    // },
    {
        key: 'settings',
        label: 'Configurações',
        isTitle: false,
        icon: 'uil-bright',
        url: '/configuracoes'
    },
];

export { MENU_ITEMS };
